module.exports = __webpack_public_path__ + "static/media/nick-drake-riverman.4665f46c.mp3";